import { Fade } from 'react-reveal';

import OverviewBanner from "./overviewBanner";
import OurMission from "./ourMission";
import InPersonWorkout from "./inPersonWorkout";
import VirtualWorkouts from "./virtualWorkouts";
import OnlineWorkouts from "./onlineWorkouts";
import AppleAndroidProducts from "./appleAndroidProducts";
import TrackActivities from "./trackActivities";
import Leaderboard from "./leaderboard";
import MeetTheTeam from "./meetTheTeam";
import MoreInformation from "./moreInformation";
import BecmomeOmniActiveInsider from "./becomeOmniActiveInsider";
import OverviewSlider from "./overviewSlider";
import WorkoutAnywhereSlider from "./workoutAnywhereSlider";
import CustomWorkouts from "./customWorkouts";
import NewsSection from "./newsSection";
import ReactGA from "react-ga";
import AnimationDesign from './animationDesign'
import VerticalGap from "../../components/VerticalGap";
import SecondTeam from './secondTeamAnimation'

import "./index.scss";

const Overview = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
  return (
    <div className="overview-page">

      <OverviewBanner />

      <VerticalGap />

      <NewsSection />

      <VerticalGap />

      <OurMission />

      <VerticalGap />

      <WorkoutAnywhereSlider />

      <VerticalGap />
      <Fade left >
        <div className="sub-heading">Guiding you</div>
      </Fade>
      <Fade right >
        <div className="heading">at every level</div>
      </Fade>
      <InPersonWorkout />

      <VerticalGap />

      <VirtualWorkouts />

      <VerticalGap />

      <OnlineWorkouts />

      <OverviewSlider />

      <VerticalGap />

      <AppleAndroidProducts />

      <VerticalGap />

      <TrackActivities />

      <VerticalGap />

      <CustomWorkouts />

      <VerticalGap />

      <Leaderboard />

      <SecondTeam />

      <VerticalGap />

      <MeetTheTeam />

      <AnimationDesign />

      <VerticalGap />

      <MoreInformation />

      <VerticalGap />

      <BecmomeOmniActiveInsider />
    </div>
  );
};

export default Overview;
